import request from './request'

// 学校列表
export function apiSchoolList(data) {
    return request({
        url: 'api/school/index',
        method: 'GET',
        params: data
    })
}
// 学校信息
export function apiSchoolIssue(data) {
    return request({
        url: 'api/school/issue_expense',
        method: 'GET',
        params: data
    })
}
// 创建订单
export function apiSetOreder(data) {
    return request({
        url: 'api/school/create_order',
        method: 'POST',
        data: data
    })
}
// 首页banner
export function apiHomeBanner() {
    return request({
        url: 'api/index/banner',
        method: 'GET'
    })
}
// 系统基础配置信息
export function apiConfig(data) {
    return request({
        url: 'api/common/init',
        method: 'GET',
        params: data
    })
}
// openid
export function apiGetOpenId(params) {
    return request({
        url: 'api/school/get_openid',
        method: 'GET',
        params: params
    })
}

export function apiGetAuthUrl(data) {
    return request({
        url: 'api/school/get_auth_url',
        method: 'POST',
        data: data
    })
}

// 订单详情
export function apiOrderDetail(data) {
    return request({
        url: 'api/school/order_detail',
        method: 'POST',
        data: data
    })
}

// 微信支付(公众号支付&PC扫码支付)
export function apiSchoolWechat(data) {
    return request({
        url: 'api/school/wechat',
        method: 'POST',
        data: data
    })
}

// 缴费新页面接口
export function apiSchoolGetIssue(data) {
    return request({
        url: 'api/school/get_issue',
        method: 'GET',
        params: data
    })
}

// 验证订单是否成功
export function apiSchoolCheckScan(data) {
    return request({
        url: 'api/school/check_scan',
        method: 'POST',
        data: data
    })
}

// 扫码进来后进入的页面
export function apiSchoolAll(data) {
    return request({
        url: 'api/school/all',
        method: 'GET',
        params: data
    })
}
// 获取乡镇信息
export function apiSchoolTown(data) {
    return request({
        url: 'api/school/town',
        method: 'GET',
        params: data
    })
}
// 获取选择学校的年级情况
export function apiSchoolChooseClass(data) {
    return request({
        url: 'api/school/get_school_class',
        method: 'GET',
        params: data
    })
}
// 获取学校项目
export function apiSchoolChooseIssue(data) {
    return request({
        url: 'api/school/issue_expense_list',
        method: 'GET',
        params: data
    })
}
// 获取乡镇列表
export function apiSchoolTownList(data) {
    return request({
        url: 'api/school/town_list',
        method: 'GET',
        params: data
    })
}
// 获取区详情
export function apiSchoolCounty(data) {
    return request({
        url: 'api/school/county',
        method: 'GET',
        params: data
    })
}









// WEBPACK FOOTER //
// ./src/api/api.js